import Errors from '~/models/errors.js'

export default {
	props: {
		loadOverridePageFilters: { type: Object },
		adminOverride: { type: Boolean, default: false },
		adminOptionsUrl: { type: String, default: null },
	},

	data() {
		return {
			page: {
				url: null,
				id: null,
				user: null,
				defaults: null,
				errors: null,
				data: null,
				page: 1,
				rows: null,
				search: '',
				reset: false,
				params: {},
				loading: true,
				updating: false,
				preUpdate: false,
				lastRequestedPayLoad: null,
				multiSelectOptions: [],
				multiSelectOptionsVisible: true,
				selected: [],
				dataName: 'data',
				onLoadData: null,
				lang: this.$en.default,
				tickRefreshStarted: false,
				manualFilters: [],
				hiddenFilters: [],
				filterOverrides: {},
				hashFilters: false,
				adminOverride: this.adminOverride,
				shouldGetAgainAfterUpdate: null,
				template: null,
				pageLoadError: null,
				set: (key, value) => {
					this.page[key] = value

					return this
				},
				call: () => {
					console.log('page called')
					return this
				},
			},
		}
	},

	mounted() {
		this.$event.$on('modal-form-completed', this.updated)
		this.$event.$on('tick-refresh', this.tickRefresh)
	},

	unmounted() {
		this.$event.$off('modal-form-completed', this.updated)
	},

	methods: {
		tickRefresh() {
			console.log('this.page.tickRefreshStarted', this.page.tickRefreshStarted)
			if (this.page.tickRefreshStarted) {
				return
			}

			this.page.tickRefreshStarted = true

			this.updated().then(() => {
				setTimeout(() => {
					this.page.tickRefreshStarted = false
				}, 2000)
			})
		},

		options(options = null) {
			if (options == null) {
				return
			}

			for (let key in options) {
				this.page[key] = options[key]
			}

			if (this.loadOverridePageFilters != undefined) {
				this.page.onLoadData = JSON.parse(this.loadOverridePageFilters)
			}

			if (this.adminOptionsUrl != undefined && this.adminOptionsUrl != null && this.adminOverride) {
				this.page.url = this.adminOptionsUrl
			}

			this.load()
		},

		load() {
			this.page.loading = true
			this.pageLoadError = null;
			this.$event.$emit('page-loading')

			this._request({
				on_load_data: this.page.onLoadData,
			}).then((res) => {
				// console.trace("request loading done");
				this.page.loading = false

				for (let key in this.page.filterOverrides) {
					if (this.page.user.filters[key] !== undefined) {
						this.page.filterOverrides[key].load()
					}
				}

				if (this.page.hashFilters) {
					this.$router.replace({ hash: '#' + JSON.stringify(this.page.user.filters) })
				}

				this.$event.$emit('page-loaded', res)
			}).catch(error => {
				console.log('load error', error.data)
				this.page.pageLoadError = error.data;

				this.$pop('PageError', {
					editingModel: this.page
				})
			})
		},

		updated(options = {}) {
			if (this.page.updating) {
				this.page.shouldGetAgainAfterUpdate = {
					page_user: this.page.user,
					page: this.page.page,
					search: this.page.search,
					reset: this.page.reset,
					...this.page.params,
				};
				return;
			}

			this.page.updating = true

			this.isSettingsATemplate()

			return Promise.resolve(
				this._request().then(() => {
					if (options.scollBottom !== undefined) {
						setTimeout(() => {
							window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight)
						}, 20)
					}

					if (this.page.hashFilters) {
						this.$router.push({ hash: '#' + JSON.stringify(this.page.user.filters) })
					}

					if (this.parentPage !== undefined) {
						this.parentPage.call().updated()
					}

					this.page.preUpdate = false
					this.page.updating = false

					if (this.page.shouldGetAgainAfterUpdate !== null) {
						this.updated();
					}

					this.$event.$emit('page-updated')
				}),
			)
		},

		save() {
			this.isSettingsATemplate()
			
			this._request({
				save: true,
			})
		},

		_request(options = {}) {
			let nextRequestedPayLoad = this.page.shouldGetAgainAfterUpdate !== null
				? this.page.shouldGetAgainAfterUpdate
				: {
					page_user: this.page.user,
					page: this.page.page,
					search: this.page.search,
					reset: this.page.reset,
					...this.page.params,
				};

			nextRequestedPayLoad.page_options = options;

			this.page.shouldGetAgainAfterUpdate = null;


			// console.log('this.page.lastRequestedPayLoad', this.page.lastRequestedPayLoad)
			// console.log('nextRequestedPayLoad', nextRequestedPayLoad)

			// if (this.page.lastRequestedPayLoad !== null && JSON.stringify(this.page.lastRequestedPayLoad) === JSON.stringify(nextRequestedPayLoad)) {
			// 	return Promise.resolve();
			// }

			// this.page.lastRequestedPayLoad = nextRequestedPayLoad;

			return Promise.resolve(
				this.$axios
					.get(this.page.url, {
						params: nextRequestedPayLoad,
					})
					.then((res) => {
						if (res.page !== undefined) {
							this.page.reset = null
							this.page.user = null

							this.page.defaults = res.page.defaults
							this.page.user = res.page.user
							this.page.template = res.template;
							this.page.defaults.filters.sort((a, b) => a.title.localeCompare(b.title))
						}

						if (options.save || options.filters) {
							return
						}

						this.page.errors = null
						this.page.data = null
						this.page.selected = null
						this.page.selected = []

						// why?
						if (res.data !== undefined) {
							this.page.data = res.data
						}

						res = this.getCallback(res)

						return res
					})
					.catch((error) => {
						throw error
						this.page.errors = new Errors(error.response.data.errors).errors
					}),
			)
		},

		getCallback(res) {
			return res
		},

		check(key) {
			if (this.page?.user?.labels == null || this.page.loading) {
				return true
			}

			if (typeof key == 'string') {
				return this.$help.getNestedArrayValue(this.page.user.labels, key) === true
			}

			if (typeof key == 'object') {
				let tested = key.length

				for (let i in key) {
					if (this.$help.getNestedArrayValue(this.page.user.labels, key[i]) !== false) {
						tested--
					}
				}

				return tested == 0
			}
		},

		toggleFilter(filter, update = true) {
			if (Array.isArray(this.page.user.filters)) {
				this.page.user.filters = {}
			}

			let canGet = true
			let filterValue = this.page.user.filters[filter.name]
			// console.log('filter', [filter, filterValue])

			if (filterValue !== undefined) {
				canGet = filterValue === null || (typeof filterValue === 'object' && filterValue.length === 0) ? false : canGet

				delete this.page.user.filters[filter.name]

				if (this.page.filterOverrides[filter.name] !== undefined) {
					this.page.filterOverrides[filter.name].removed()
				}
				// added to hide when all un selected
				// this.page.user.filters[filter.name] = []
			} else {
				this.page.user.filters[filter.name] =
					filter.type === 'checkbox' && filter.default_value === null ? [] : filter.default_value

				if (this.page.filterOverrides[filter.name] !== undefined) {
					this.page.filterOverrides[filter.name].load()
					this.page.filterOverrides[filter.name].change(filter, filter.default_value)
				}

				canGet = filter.default_value === null ? false : canGet
			}

			// console.log('canGet', canGet)

			if (canGet) {
				this.page.page = 1
				// this.set('page', 1)
			}

			if (update) {
				this.updated()
			}
		},

		removeFilter(filter) {
			delete this.page.user.filters[filter.name]

			if (this.page.filterOverrides[filter.name] !== undefined) {
				this.page.filterOverrides[filter.name].removed()
			}

			return this
		},

		addFilter(filter) {
			if (this.page.user.filters[filter.name] !== undefined) {
				return;
			}

			if (this.page.user.filters[filter.name] !== undefined) {
				// this.toggleFilter(filter)
			}
		},

		manualFilterChange(filter, value) {
			console.log(this.page.user.filters)

			for (let c in filter.change) {
				console.log(c, filter.change[c].value(filter))
				this.page.user.filters[c] = filter.change[c].value(filter)
			}

			this.updated()
		},

		reset() {
			this.page.reset = 'reset'
			this.page.hiddenFilters = []
			// this.load()
			this.updated()
		},

		multiSelectOptions() {
			let tmp = []

			if (this.page.selected.length == 0 || this.page.multiSelectOptions.length == 0) {
				return
			}

			for (let key in this.page.multiSelectOptions) {
				let selected = this.page.data.data.filter((row) => {
					return this.page.selected.indexOf(row.id) >= 0 && this.page.multiSelectOptions[key].count(row)
				})

				tmp.push({
					enabled: selected.length > 0,
					selected: selected.map((a) => a.id),
					action: this.page.multiSelectOptions[key].action !== undefined ? this.page.multiSelectOptions[key].action : false,
					subMenu: this.page.multiSelectOptions[key].subMenu ? 'data-ignore-click' : 'data-close',
					title: this.page.multiSelectOptions[key].title
						.replace(':count-force', selected.length)
						.replace(':count', selected.length == 1 ? '' : selected.length)
						.replace(':s', selected.length != 1 ? 's' : '')
						.replace(':a', selected.length == 1 ? 'a' : '')
						.replace(':name', this.$help.pluralize(this.page.dataName, selected.length))
						.trim(),
				})
			}

			return tmp
		},

		getUserFilter(filter) {
			if (this.page.user == null) {
				return {}
			}

			return this.page.user.filters[filter]
		},

		setTemplate(name, data) {
			if (data == null) {
				this.page.user.template = 'default';
				this.page.call().reset()
			} else {
				this.page.user = JSON.parse(typeof data == "object" && data != null ? data.settings : data);
				this.page.user.template = name;
				this.updated();
			}
		},

		isSettingsATemplate() {
			// let t = this.defaults.templates
			let foundKey = null
			let current = toRaw(this.page.user)
			delete current.template
			current = JSON.stringify(current)
			
			for (const [key, value] of Object.entries(this.page.defaults.templates)) {
				let t = typeof value == 'object' && value != null ? value.settings : value;
				if (t != null) {
					t = JSON.parse(t)
					delete t.template;

					if (JSON.stringify(t) == current) {
						foundKey = key
					}
				}
			}

			this.page.user.template = foundKey
		}
	},

	watch: {
		'$route.hash': function (hash) {
			if (!this.page.hashFilters || hash == '') {
				return
			}

			this.page.user.filters = JSON.parse(hash.substring(1))
			this.page.call().updated()
		}
	}
}
